export class PersonCertificationWrite {
  public id: string;
  public name: string;
  public number: string;
  public activeDate: Date;
  public expirationDate: Date;
  public url: string;

  constructor() {}
}
